const languageContainer = require('./language-container');

const LOCAL_STORAGE_KEY = "cnsIgnoredWordsDictionary";
const IGNORE_ALL_SYMBOL = "*";;

class SpellcheckStorage {
    constructor() {

    }

    isIgnored(word, captionId) {
        let ignoredWordsDictionary = this._getCurrentWorkDictionary();
        return ignoredWordsDictionary[word] != null && (ignoredWordsDictionary[word] === IGNORE_ALL_SYMBOL || ignoredWordsDictionary[word][captionId]);
    }

    ignore(word, captionId) {
        let currentWorkIgnoredWordsDictionary = this._getCurrentWorkDictionary();
        if (currentWorkIgnoredWordsDictionary[word] == null) {
            currentWorkIgnoredWordsDictionary[word] = {};
        };

        currentWorkIgnoredWordsDictionary[word][captionId] = true;
        this._save(currentWorkIgnoredWordsDictionary);   
    }

    ignoreAll(word) {
        let currentWorkIgnoredWordsDictionary = this._getCurrentWorkDictionary();
        currentWorkIgnoredWordsDictionary[word] = IGNORE_ALL_SYMBOL;
        this._save(currentWorkIgnoredWordsDictionary);         
    }

    _getCurrentWorkDictionary() {   
        let ignoredWordsDictionary = this._get();
        let currentWorkId = languageContainer.get().key;
      
        return ignoredWordsDictionary[currentWorkId] || {};
    }

    _get() {
        let ignoredWordsDictionaryAsStr = localStorage.getItem(LOCAL_STORAGE_KEY);
        return ignoredWordsDictionaryAsStr == null ? {} : JSON.parse(ignoredWordsDictionaryAsStr);
    }

    _save(currentWorkIgnoredWordsDictionary) {
        let ignoredWordsDictionary = this._get();
        let currentWorkId = languageContainer.get().key;
        ignoredWordsDictionary[currentWorkId] = currentWorkIgnoredWordsDictionary;
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(ignoredWordsDictionary))
    }
}

module.exports = new SpellcheckStorage();


// WEBPACK FOOTER //
// ./app/helpers/spellchecker-storage.js